export default __webpack_public_path__ + "static/media/ProductSans-Light.8b23ea2f.ttf";